export default "__VITE_ASSET__BXPGRQGy__"